// Adjusts the SortableJS lists Filament creates, including the ones Livewire renders later

// Chrome does not scroll the page while dragging, so let SortableJS scroll it by hand
const autoScrollOptions = {
    forceAutoScrollFallback: true,
    scrollSensitivity: 100,
    scrollSpeed: 15,
};

// Firefox holds the dragged item by its top left corner, so hold it where it was grabbed instead
let grabPoint;

const dragImageOptions = {
    onChoose: (event) => {
        grabPoint = event.originalEvent;
    },
    setData: (dataTransfer, item) => {
        const { left, top } = item.getBoundingClientRect();

        dataTransfer.setDragImage(item, grabPoint.clientX - left, grabPoint.clientY - top);
        // SortableJS's default, which Firefox needs for the drag to start at all
        dataTransfer.setData('Text', item.textContent);
    },
};

// Drag from anywhere on the item header, except its actions and the item content (nested lists)
const dragByHeaderOptions = {
    handle: '.fi-fo-repeater-item-header, .fi-fo-builder-item-header',
    filter: [
        '.fi-fo-repeater-item-header-end-actions',
        '.fi-fo-builder-item-header-end-actions',
        '.fi-fo-repeater-item-content',
        '.fi-fo-builder-item-content',
    ].join(', '),
    preventOnFilter: false,
};

document.addEventListener('alpine:init', () => {
    const sortable = window.Sortable;

    if (!sortable || sortable.isPatched) {
        return;
    }

    const create = sortable.create.bind(sortable);

    sortable.create = (element, options) => create(element, {
        ...options,
        ...autoScrollOptions,
        ...dragImageOptions,
        // Only the list marked itself, not the lists nested in its items
        ...(element.parentElement?.classList.contains('drag-by-header') ? dragByHeaderOptions : {}),
    });

    sortable.isPatched = true;
});
